<script setup>
import { RBN_ACCOUNT_PROFILE } from '@/utils/constants';

definePageMeta({
  middleware: (to) => {
    const localePath = useLocalePath();
    return navigateTo(localePath({ name: RBN_ACCOUNT_PROFILE, params: to.params, query: to.query }));
  },
});
</script>
